<template>
    <b-overlay :show="loading">
        <CompetitionLocationMap :results="filteredResults" />
        <ResultsFilterControl v-model="selected" />
        <ResultsTable :results="filteredResults" />
    </b-overlay>
</template>

<script>
import ResultsFilterControl from './ResultsFilterControl.vue';
import ResultsTable from './ResultsTable.vue';
import CompetitionLocationMap from './CompetitionLocationMap.vue';
import { fetchMappedResults } from '@/data/results';
import { singleTagFilter } from '@/common/tagFiltering';

export default {
    data() {
        return {
            selected: "all",
            results: [],
            loading: true
        };
    },
    computed: {
        resultsBySeason() {
            const array = this.results;
            const key = 'season';
            const result = {};
            array.forEach(item => {
                if (!result[item[key]]) {
                    result[item[key]] = [];
                }
                result[item[key]].push(item);
            });
            return result
        },
        filteredResults() {
            if (this.selected === "all")
                return this.results;
            
            return this.results.filter(singleTagFilter(this.selected));
        }
    },
    components: {
        CompetitionLocationMap,
        ResultsFilterControl,
        ResultsTable
    },
    created() {
        fetchMappedResults()
            .then(results => {
                this.results = results;
                this.loading = false;
            });
    }
}
</script>